module.exports = __webpack_public_path__ + "static/media/Create-Table-Purple.40e37074.png";